'use client';

import { useEffect } from 'react';
import { getCookie, setCookie } from '@/utils/cookies';
import { Breakpoint, breakpoints, BREAKPOINT_COOKIE, TYPE_COOKIE } from '@Constants/common.constants';

export type ScreenType = 'mobile' | 'desktop';

const detectScreenData = (): { breakpoint: Breakpoint; type: ScreenType } => {
    if (typeof window === 'undefined') {
        return { breakpoint: 'xl', type: 'desktop' };
    }

    const width = window.innerWidth;
    let breakpoint: Breakpoint = 'xs';

    if (width >= breakpoints['3xl']) breakpoint = '3xl';
    else if (width >= breakpoints['2xl']) breakpoint = '2xl';
    else if (width >= breakpoints.xl) breakpoint = 'xl';
    else if (width >= breakpoints.lg) breakpoint = 'lg';
    else if (width >= breakpoints.md) breakpoint = 'md';
    else if (width >= breakpoints.sm) breakpoint = 'sm';
    else breakpoint = 'xs';

    const type: ScreenType = width < breakpoints.sm ? 'mobile' : 'desktop';

    return { breakpoint, type };
};

export const useScreenDetection = () => {
    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        const updateScreenData = () => {
            const { breakpoint, type } = detectScreenData();

            const currentBreakpoint = getCookie(BREAKPOINT_COOKIE);
            const currentType = getCookie(TYPE_COOKIE);

            if (currentBreakpoint !== breakpoint) {
                setCookie(BREAKPOINT_COOKIE, breakpoint);
            }

            if (currentType !== type) {
                setCookie(TYPE_COOKIE, type);
            }
        };

        // Debounced resize handler
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(updateScreenData, 150);
        };

        updateScreenData(); // Установить при монтировании
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timeoutId);
        };
    }, []);
};
